if (!customElements.get('section-half')) {
  customElements.define(
    'section-half',
    class SectionHalf extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        if (this.querySelector('[data-gif-container]') != undefined && this.querySelectorAll('[data-gif-container]').length > 0){
          const gifContainers = this.querySelectorAll('[data-gif-container]');
          gifContainers.forEach((gifContainer) => {
            const image = gifContainer.querySelector('img');
            const gifDuration = parseInt(gifContainer.dataset.gifDuration)
            setInterval(() => {
              const baseSrc = image.dataset.baseSrc;
              const baseSrcset = image.dataset.baseSrcset;
              image.setAttribute('src', baseSrc.replaceAll('&width', `&reload=${Math.random()}&width`))
              image.setAttribute('srcset', baseSrcset.replaceAll('&width', `&reload=${Math.random()}&width`))
            }, gifDuration)
          })
        }
      }
    }
  )
}
